import store from '@/store'
import { env } from '@/config'

export default {
    methods: {
        $appConfig(configKey, defaultValue = undefined, formatter = (v) => v) {
            const configData = Object.assign(env, store.getters.serverConfig)

            if (typeof configData[configKey] == 'undefined') {
                return defaultValue
            }

            return formatter(configData[configKey])
        },
        $appConfigBool(...args) {
            return this.$appConfig(args[0], args[1], (value) => {
                if (!value || value === '0' || value === 'false') {
                    return false
                }

                return !!value
            })
        },
        $appConfigJSON(...args) {
            return this.$appConfig(args[0], args[1], (value) => {
                return JSON.parse(value)
            })
        }
    },
}
